import component from "containers/StaticPages/verifyEmail";

export default {
  key: "verify-email",
  title: "Verify Email",
  path: "/verify-email/:token",
  linkTarget: "/verify-email",
  component,
};
